import { Obj } from "../internal";
import { USERINPUTTYPE } from "../userinput/internal";
import { MultiBboxStrategy } from "./strategy/internal";
export var FEATURELOADINGSTRATEGY;
(function (FEATURELOADINGSTRATEGY) {
    FEATURELOADINGSTRATEGY[FEATURELOADINGSTRATEGY["ALL"] = 1] = "ALL";
    FEATURELOADINGSTRATEGY[FEATURELOADINGSTRATEGY["BBOX"] = 2] = "BBOX";
})(FEATURELOADINGSTRATEGY || (FEATURELOADINGSTRATEGY = {}));
/**
 *
 * Handles the call of the layers 'loadFeatures'-function depending on a selected strategy.
 * @class StrategyHandler
 * @author Joel Burkhard
 *
 */
export class StrategyHandler extends Obj {
    constructor(scene) {
        super();
        /**
         * list of layers managed by the strategyhandler.
         * @type {Array}
         */
        this.layers = [];
        /**
         * bounding-box of the current segment
         * @type {{segmentid: number}}
         */
        this.allbbox = {
            bbox: { minx: 0, miny: 0, maxx: 99999999, maxy: 99999999 },
            srid: 2056,
        };
        this._strategies = {};
        this.scene = scene;
        this._strategies[FEATURELOADINGSTRATEGY.BBOX] = new MultiBboxStrategy(scene);
    }
    /**
     * initializes the segment-strategy once the first layer with this strategy was added.
     * @private
     */
    _initAllStrategy() {
        //register _segmentchanged
        this.ennchangedevt = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.GEOFRAMECOLLECTIONCHANGED, (geoframecollection) => {
            this.allbbox.srid = geoframecollection.getCurrentGeoFrame().srid;
            this._update(FEATURELOADINGSTRATEGY.ALL);
        }, this);
        //register layerupdated
        this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE["LAYERUPDATED"], (layer) => {
            if (layer.needsReload)
                this._update(FEATURELOADINGSTRATEGY.ALL);
        }, this);
    }
    /**
     * adds or registers a layer in the strategy-handler. by the time of registring the 'needsReload'-indicator of
     * all layers is set to true.
     * todo: init segment-strategy only for segment-layers
     * @param layer
     */
    register(layer) {
        this.layers.push(layer);
        switch (layer.strategy) {
            case FEATURELOADINGSTRATEGY.ALL:
                if (this.scene.getCurrentGeoframe()) {
                    this.allbbox.srid = this.scene.getCurrentGeoframe().srid;
                    this._update(FEATURELOADINGSTRATEGY.ALL);
                }
                if (!this.ennchangedevt)
                    this._initAllStrategy();
                break;
            case FEATURELOADINGSTRATEGY.BBOX:
                this._strategies[FEATURELOADINGSTRATEGY.BBOX].register(layer);
                break;
        }
    }
    /**
     * removes a layer from the strategy-handler
     * @param layer
     */
    remove(layer) {
        switch (layer.strategy) {
            case FEATURELOADINGSTRATEGY.BBOX:
                this._strategies[FEATURELOADINGSTRATEGY.BBOX].remove(layer);
                break;
        }
        for (let i = 0; i < this.layers.length; i++) {
            if (this.layers[i] === layer)
                this.layers.splice(i, 1);
        }
    }
    _getExtentFromStrategy(strategy) {
        switch (strategy) {
            case FEATURELOADINGSTRATEGY.ALL:
                return { extent: this.allbbox.bbox, srid: this.allbbox.srid };
        }
    }
    /**
     * updates all layers marked with needsReload=true.
     * @private
     */
    _update(strategy) {
        const extent = this._getExtentFromStrategy(strategy);
        for (let i = 0; i < this.layers.length; i++) {
            const layer = this.layers[i];
            if (layer.needsReload && strategy == layer.strategy) {
                layer.needsReload = false;
                layer.loadFeatures(extent.extent, extent.srid);
            }
        }
    }
    /**
     * static function to convert the featureloadingstrategy-type-string to the featureloadingstrategy-enum.
     * @method toNumber
     * @param {string} type
     * @return {FEATURELOADINGSTRATEGY}
     */
    static strategyToNumber(type) {
        if (typeof type == "number")
            return type;
        switch (type) {
            case "undefined":
                return FEATURELOADINGSTRATEGY.BBOX;
            case "segment":
                console.log("Warning: Feature loading strategy 'segment' is not supported anymore. The new default is 'bbox'");
                return FEATURELOADINGSTRATEGY.BBOX;
            case "all":
                return FEATURELOADINGSTRATEGY.ALL;
            case "bbox":
                return FEATURELOADINGSTRATEGY.BBOX;
        }
        return FEATURELOADINGSTRATEGY.BBOX;
    }
}
//# sourceMappingURL=strategyhandler.js.map